import axios from './ConfiguredAxios';
import App from 'PublicJs/App';

const EventsApi  = {

	getEvent: (eventId) => {
		let url = App.getLocale() + '/events/view/' + eventId;
		return axios.get(url);
	}
};

export default EventsApi;
